module.exports = __webpack_public_path__ + "img/order-empty.76ef4bb9.png";